export default __webpack_public_path__ + "static/media/MAIN.93c5c1ab.png";